export default function AboutSection() {
  return (
    <section id="about-pixelutility" className="py-20 sm:py-28 px-4 border-t border-gray-100">
      <div className="max-w-3xl mx-auto">
        <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 text-center">
          What Is PixelUtility?
        </h2>
        <div className="mt-8 space-y-5 text-gray-600 leading-relaxed text-base sm:text-lg">
          <p>
            <strong className="text-gray-900">PixelUtility</strong> is a growing collection of free,
            modern online tools designed for job seekers, freelancers, small businesses, and anyone
            who wants simple productivity software without subscriptions or complicated sign-up flows.
          </p>
          <p>
            Our mission is to make everyday tasks faster: build a professional{' '}
            <a href="/tools/resume-builder" className="text-brand-600 hover:underline font-medium">
              ATS-friendly resume
            </a>
            , generate clean{' '}
            <a href="/tools/qr-code-generator" className="text-brand-600 hover:underline font-medium">
              QR codes
            </a>
            , and convert{' '}
            <a href="/tools/clothing-shoe-size-converter" className="text-brand-600 hover:underline font-medium">
              international clothing and shoe sizes
            </a>
            — all from fast, mobile-friendly guides and browser tools.
          </p>
          <p>
            Privacy comes first. Whenever possible, our tools process your data locally in your
            browser, so resumes, PDFs, and images stay on your device instead of being uploaded to a
            server. No account is required to get started, and our core tools are free to use.
          </p>
          <p>
            Browse our{' '}
            <a href="#tools" className="text-brand-600 hover:underline font-medium">
              featured tools
            </a>
            , read articles on the{' '}
            <a href="/blog" className="text-brand-600 hover:underline font-medium">
              blog
            </a>
            , and launch each utility when you are ready — we only publish tools that are fully live.
          </p>
        </div>
      </div>
    </section>
  );
}
